import InputDesc from "#app/pages/IncomeAndExpenses/components/BaseOperationList/form/InputDesc";
import {EditText, Plus} from "#app/pages/IncomeAndExpenses/components/BaseOperationList/style";
import React, {useState} from "react";

export const DescDisplay = ({ item, isNotVisibleSum }) => {
    const [editDesc, setEditDesc] = useState(false);

    if (item.editable && !item.comment && !editDesc) {
        return (
            <Plus id={`edit-tag-${item.id}`} onClick={() => setEditDesc(true)} />
        );
    }

    return item.editable && editDesc ? (
        <InputDesc item={item} finishEdit={() => setEditDesc(false)} />
    ) : (
        <EditText id={`edit-desc-${item.id}`} data-tooltip-content={item.comment} onClick={() => setEditDesc(true)}>
            {isNotVisibleSum ? '******' : (item.comment.length > 18 ? item.comment.substr(0, 17) + '...' : item.comment)}
        </EditText>
    );
}